<template>
  <div class="chufang">
    <div class="chufangbg">
      <appHeader activeIndex="chufang" ></appHeader>
      <div class="chufangContent">
        <!-- 介绍 -->
        <div class="chufangInfo">
          <div class="chufangInfo1">
            <img class="chufangInfo1Img1" src="../../assets/img/Product/chufang.png"  alt />
            <br><br><br><br><br>
            <!-- <img class="chufangInfo1Img2"  src="../../assets/img/products/chufang/chufangQRcode.png" alt /> -->
            <!-- <div>扫描二维码下载</div>      -->
          </div>
          <div class="chufangInfo2">
            <div class="productTitle">
              宝宝美食厨房
            </div>
            <br>
            在这个快节奏和有趣的宝宝美食厨房中扮演厨师，烹饪世界各地的美味佳肴！
            <br><br>
             <el-divider></el-divider>
             <h2>产品特色</h2>
             <p>【四大美食主题店】
无论是牛排汉堡，还是路边小摊，又或者是甜品蛋糕，只有您想不到，没有我们做不到！美食厨房为大厨们准备好了新鲜的食材和丰富的菜品，等待各位大厨宝宝们大显身手！</p>
             <p>【超多关卡来挑战】
每个主题餐厅都有超过20个关卡地图，升级关卡，挑战自己的厨艺，成为主题餐厅中最出色的大厨宝宝吧！</p>
             <p>【餐厅升级更好玩】
宝宝美食厨房会根据进度为您推荐餐厅需要升级设备，获取金币用来开启更多道具，为你在升级解锁新餐厅的道路上加油助威！</p>
             <p>【一键上菜服务】
初次体验本产品的宝宝，一定要体验一键上菜服务，超级有趣，能让操作进度加快，您只需把顾客需要的菜品准备好就可以，系统会自动为您上菜哦！</p>
          </div>
          <div style="clear: both;"></div> 
        </div>
        <!-- 第二部分内容 -->
        <el-divider></el-divider>
        <div class="chufangCarousel">
          <div class="iconLeft" @click="left"><el-button icon="el-icon-arrow-left" circle></el-button></div>
          <div class="iconRight" @click="right"><el-button icon="el-icon-arrow-right" circle></el-button></div>
          <div class="chufangWrap">
            <div class="chufangMainImg" :style="{ left: nowLeft + '%' }">
              <img class="chufangCarouselImg"   src="../../assets/img/products/chufang/carousel.png" alt />
            </div>
          </div>
          
        </div>
      </div>
    </div>
    <appFooter></appFooter>

  </div>
</template>
 
<script>
import appHeader from "../components/Header";
import appFooter from "../components/Footer";
export default {
  components: {
    appHeader,appFooter
  },
  data() {
    return {
      nowLeft: 0
    };
  },
  mounted() {},
  methods: {
    
      left() {
        
        if(this.nowLeft >= 0){
          return;
        }
        this.nowLeft = this.nowLeft +15
      },

      right() {
        if(this.nowLeft <= -45){
          return;
        }
        this.nowLeft = this.nowLeft -15
      }
  }
};
</script>
<style>
@import "../../assets/css/products/chufang.css";
@import "../../assets/css/products/product.css";
</style>
